import image from '../../Designs/logovalentina.png';

const Logo = ({width}) => {
	return <img src={image} width={width} height={'auto'}/>
}

export default Logo;